import { render, staticRenderFns } from "./ChooseResvItem.vue?vue&type=template&id=ad9a6b26&"
import script from "./ChooseResvItem.vue?vue&type=script&lang=js&"
export * from "./ChooseResvItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports